import React from 'react';
import { useHandleEscPress } from 'common/hooks';
import { cx } from 'linaria';
import { modalOverlay, active } from './styles';

interface ModalOverlayProps {
  onClose: () => void;
  expanded: boolean;
}

export const ModalOverlay = (props: ModalOverlayProps) => {
  const { onClose, expanded } = props;
  useHandleEscPress(onClose);

  return <div onClick={onClose} className={cx(modalOverlay, expanded && active)} />;
};
